import { protectedResources } from "../authConfig";
import { msalInstance } from "../msalInstance";

async function fetchToken() {
  const currentAccount = msalInstance.getActiveAccount();
  const accessTokenRequest = {
    scopes: protectedResources.management.scopes.read,
    account: currentAccount,
  };
  if (currentAccount) {
    // @ts-ignore
    return await msalInstance.acquireTokenSilent(accessTokenRequest);
  }
  return null;
}

const getToken = async () => {
  try {
    const token = await fetchToken();
    console.log("=============================================token ===  " + token);
    if (token) {
      return token;
    }
    // No token - return null, let the app handle unauthenticated state
    return null;
  } catch (error) {
    console.error("Error fetching token:", error);
    // Clear MSAL storage on error
    Object.keys(window.localStorage).forEach(function (key) {
      if (key.startsWith("msal")) {
        window.localStorage.removeItem(key);
      }
    });
    Object.keys(window.sessionStorage).forEach(function (key) {
      if (key.startsWith("msal")) {
        window.sessionStorage.removeItem(key);
      }
    });
    return null;
  }
};

export default getToken;
